<template>
  <div class="container p-3">

    <div class="row py-4 ps-4">
      <div class="col justify-content-start d-flex ">
        <p class="h1 fw-bolder text-primary">John Chang's Resume</p>
      </div>
      <div class="col justify-content-end d-flex ">
        <a href="https://www.datacamp.com/certificate/DSA0018114868078">
          <img height="150"
               class="border-2 border p-1 rounded rounded-4 shadow mx-1"
               src="/DataCamp DS.png"/>
        </a>
        <a href="https://google.accredible.com/82d7b2f2-5362-4bce-a8ef-36a62fd1de21">
          <img height="150" width="150"
               class="border-2 border p-1 rounded rounded-4 shadow mx-1"
               src="https://api.accredible.com/v1/frontend/credential_website_embed_image/badge/76966447">
        </a>
      </div>
    </div>
    <div class="row py-4 ps-4">
      <div class="col-12 d-flex justify-content-center">
        <object data="/Resume.pdf" width="1200" height="1600" class="shadow m-1"></object>
      </div>
    </div>
  </div>
</template>

<style scoped>
</style>
<script setup lang="ts">
</script>